import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Sponsors',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'sponsors',
                },
              },
              subqueries: {
                sponsors: {
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>': [
                          {
                            '#': {
                              '@': 'pis',
                            },
                          },
                          0,
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'ent:!sponsors:!sponsor',
                  subqueries: {
                    pis: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        '=': [
                          {
                            '@.': '!id',
                          },
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                        ],
                      },
                      target: 'ent:!personnel:!employee',
                    },
                    projects: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!sponsor',
                      },
                      target: 'ent:!projects:!proj',
                    },
                    glExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projects',
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          tdcAmount: {
                            if: [
                              [
                                {
                                  not: {
                                    '=': [
                                      {
                                        '@': 'costType',
                                      },
                                      'IDC',
                                    ],
                                  },
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          idcrAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'IDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          mtdcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!cost_type',
                          },
                        },
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      using: 'projects',
                      target: 'ent:!proj_pis:!entry',
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                or: [
                  {
                    '=': [
                      {
                        '``': {
                          '@$': 'piRecordId',
                        },
                      },
                      null,
                    ],
                  },
                  {
                    '>': [
                      {
                        '#': {
                          '@': 'pis',
                        },
                      },
                      0,
                    ],
                  },
                ],
              },
              period: {
                '``': {
                  '@$': 'focusedRange',
                },
              },
              target: 'ent:!sponsors:!sponsor',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      tdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      idcr: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'idcrAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'projects',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      effectiveRecovery: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'mtdcAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                              {
                                '/': [
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'glExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'idcrAmount',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'glExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'mtdcAmount',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                pis: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!pi',
                  },
                  using: 'projectPiAssignments',
                  filter: {
                    '=': [
                      {
                        '@.': '!id',
                      },
                      {
                        '``': {
                          '@$': 'piRecordId',
                        },
                      },
                    ],
                  },
                  target: 'ent:!personnel:!employee',
                },
                projects: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!sponsor',
                  },
                  target: 'ent:!projects:!proj',
                },
                glExpenses: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  using: 'projects',
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '{}': {
                      tdcAmount: {
                        if: [
                          [
                            {
                              not: {
                                '=': [
                                  {
                                    '@': 'costType',
                                  },
                                  'IDC',
                                ],
                              },
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      idcrAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'IDC',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      mtdcAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'MTDC',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    costType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!cost_type',
                      },
                    },
                  },
                },
                projectPiAssignments: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!proj',
                  },
                  using: 'projects',
                  target: 'ent:!proj_pis:!entry',
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!sponsors#!sponsor:!code',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!sponsors#!sponsor:!name',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'tdc',
                  direct: {
                    '{}': {
                      name: 'TDC Expense',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'mtdc',
                  direct: {
                    '{}': {
                      name: 'MTDC Expense',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'idcr',
                  direct: {
                    '{}': {
                      name: 'IDC-R',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'effectiveRecovery',
                  direct: {
                    '{}': {
                      name: 'Effective Recovery',
                      type: 'PERCENT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'projects',
                  direct: {
                    '{}': {
                      name: 'Projects',
                      type: 'INT',
                    },
                  },
                },
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      tdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      idcr: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'idcr',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'projects',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      effectiveRecovery: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'records',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'mtdc',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                0,
                              ],
                              {
                                '/': [
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'records',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'idcr',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'records',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'mtdc',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>': [
                          {
                            '#': {
                              '@': 'pis',
                            },
                          },
                          0,
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'ent:!sponsors:!sponsor',
                  selection: {
                    '{}': {
                      tdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'glExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'tdcAmount',
                              ],
                            },
                          ],
                        },
                      },
                      idcr: {
                        '+': {
                          '->': [
                            {
                              '@': 'glExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'idcrAmount',
                              ],
                            },
                          ],
                        },
                      },
                      mtdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'glExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'mtdcAmount',
                              ],
                            },
                          ],
                        },
                      },
                      projects: {
                        '??': [
                          {
                            '#': {
                              '@': 'projects',
                            },
                          },
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    pis: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        '=': [
                          {
                            '@.': '!id',
                          },
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                        ],
                      },
                      target: 'ent:!personnel:!employee',
                    },
                    projects: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!sponsor',
                      },
                      target: 'ent:!projects:!proj',
                    },
                    glExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projects',
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          tdcAmount: {
                            if: [
                              [
                                {
                                  not: {
                                    '=': [
                                      {
                                        '@': 'costType',
                                      },
                                      'IDC',
                                    ],
                                  },
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          idcrAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'IDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          mtdcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!cost_type',
                          },
                        },
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      using: 'projects',
                      target: 'ent:!proj_pis:!entry',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2023',
        },
        start: {
          $date: '1/1/2023',
        },
      },
    },
  },
}
